import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../../../services/api';
import { useNotifications } from '../../../contexts/NotificationContext';
import styles from './ResetPassword.module.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [formData, setFormData] = useState({
    password: '',
    password_confirmation: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { addNotification } = useNotifications();

  useEffect(() => {
    if (!token) {
      addNotification('Token de réinitialisation manquant', 'error');
      navigate('/forgot-password');
    }
  }, [token, navigate, addNotification]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.password || !formData.password_confirmation) {
      addNotification('Veuillez remplir tous les champs', 'error');
      return;
    }

    if (formData.password.length < 8) {
      addNotification('Le mot de passe doit contenir au moins 8 caractères', 'error');
      return;
    }

    if (formData.password !== formData.password_confirmation) {
      addNotification('Les mots de passe ne correspondent pas', 'error');
      return;
    }

    setIsLoading(true);

    try {
      const response = await authService.resetPassword(token, {
        password: formData.password,
        password_confirmation: formData.password_confirmation
      });

      if (response.success) {
        setIsSuccess(true);
        addNotification('Mot de passe réinitialisé avec succès !', 'success');

        // Rediriger vers la page de connexion après 2 secondes
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        addNotification(response.message || 'Erreur lors de la réinitialisation', 'error');
      }
    } catch (error) {
      addNotification(
        error.response?.data?.message || 'Erreur lors de la réinitialisation du mot de passe',
        'error'
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (!token) {
    return null;
  }

  return (
    <div className={styles.resetPassword}>
      <div className={styles.container}>
        <div className={styles.card}>
          <h2>Réinitialiser le mot de passe</h2>

          {isSuccess ? (
            <div className={styles.successMessage}>
              <p>✅ Votre mot de passe a été réinitialisé avec succès !</p>
              <p>Redirection vers la page de connexion...</p>
            </div>
          ) : (
            <>
              <p className={styles.description}>
                Entrez votre nouveau mot de passe ci-dessous.
              </p>

              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.formGroup}>
                  <label htmlFor="password">Nouveau mot de passe</label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Minimum 8 caractères"
                    required
                    minLength={8}
                    disabled={isLoading}
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="password_confirmation">Confirmer le mot de passe</label>
                  <input
                    type="password"
                    id="password_confirmation"
                    name="password_confirmation"
                    value={formData.password_confirmation}
                    onChange={handleChange}
                    placeholder="Répétez le mot de passe"
                    required
                    minLength={8}
                    disabled={isLoading}
                  />
                </div>

                <button
                  type="submit"
                  className={styles.submitButton}
                  disabled={isLoading}
                >
                  {isLoading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
                </button>
              </form>

              <div className={styles.footer}>
                <Link to="/login" className={styles.link}>
                  Retour à la connexion
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;

